import { render, staticRenderFns } from "./departmentSelector.vue?vue&type=template&id=f7dcafdc"
import script from "./departmentSelector.vue?vue&type=script&lang=js"
export * from "./departmentSelector.vue?vue&type=script&lang=js"
import style0 from "./departmentSelector.vue?vue&type=style&index=0&id=f7dcafdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports